const USER_STORAGE_KEY = 'gaza_pharmacy_user';
const TOKEN_STORAGE_KEY = 'gaza_pharmacy_token';

export function handleUnauthorizedResponse() {
  if (typeof window !== 'undefined' && window.__IS_PLAYWRIGHT_TEST__) {
    console.warn('Ignored session expiration during automated test execution');
    const error = new Error('Your session has expired. Please sign in again.');
    error.name = 'UnauthorizedError';
    return error;
  }

  localStorage.removeItem(USER_STORAGE_KEY);
  localStorage.removeItem(TOKEN_STORAGE_KEY);

  // Keep AuthContext's in-memory state in step with storage. Without this,
  // a 401 received while the login page is mounted can leave React believing
  // the user is signed in and immediately send them back to a protected page.
  if (typeof window.dispatchEvent === 'function' && typeof Event === 'function') {
    window.dispatchEvent(new Event('gaza-auth-expired'));
  }

  // Several requests can fail together when a token expires. Only the first
  // one may navigate; subsequent failures must not create a redirect storm.
  if (window.location.pathname !== '/login' && !window.__gazaAuthRedirecting) {
    window.__gazaAuthRedirecting = true;
    window.location.replace('/login');
  }

  const error = new Error('Your session has expired. Please sign in again.');
  error.name = 'UnauthorizedError';
  return error;
}
